// extracted by mini-css-extract-plugin
module.exports = {"contentTable":"ContentTable_contentTable__2A6HC"};